//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SHIFTENTRY_API_BASE_URL = new InjectionToken<string>('SHIFTENTRY_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ShiftEntryApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SHIFTENTRY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the employers associated with a caregiver during the given date range.
     * @param dateRangeEnd (optional) 
     * @return The associated employers.
     */
    employersAll(caregiverId: number, dateRangeStart: string, dateRangeEnd?: string | undefined): Observable<EmployerResponse[]> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/employers?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (dateRangeStart === undefined || dateRangeStart === null)
            throw new globalThis.Error("The parameter 'dateRangeStart' must be defined and cannot be null.");
        else
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd === null)
            throw new globalThis.Error("The parameter 'dateRangeEnd' cannot be null.");
        else if (dateRangeEnd !== undefined)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployersAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerResponse[]>;
        }));
    }

    protected processEmployersAll(response: HttpResponseBase): Observable<EmployerResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets details of an employer associated with a caregiver on a given date.
     * @param date (optional) 
     * @return The employer's details.
     */
    employers(caregiverId: number, employerId: number, date?: string | undefined): Observable<EmployerDetailsResponse> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/employers/{employerId}?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (employerId === undefined || employerId === null)
            throw new globalThis.Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerDetailsResponse>;
        }));
    }

    protected processEmployers(response: HttpResponseBase): Observable<EmployerDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the participants associated with a caregiver during the given date range.
     * @param dateRangeEnd (optional) 
     * @return The associated participants.
     */
    participantsAll(caregiverId: number, dateRangeStart: string, dateRangeEnd?: string | undefined): Observable<ParticipantResponse[]> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/participants?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (dateRangeStart === undefined || dateRangeStart === null)
            throw new globalThis.Error("The parameter 'dateRangeStart' must be defined and cannot be null.");
        else
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd === null)
            throw new globalThis.Error("The parameter 'dateRangeEnd' cannot be null.");
        else if (dateRangeEnd !== undefined)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantResponse[]>;
        }));
    }

    protected processParticipantsAll(response: HttpResponseBase): Observable<ParticipantResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets details of a participant associated with a caregiver on a given date.
     * @return The participant's details.
     */
    participants(caregiverId: number, participantId: number, date: string): Observable<ParticipantDetailsResponse> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/participants/{participantId}?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDetailsResponse>;
        }));
    }

    protected processParticipants(response: HttpResponseBase): Observable<ParticipantDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a shift for the given caregiver.
     * @param overrideWarnings (optional) 
     * @param body (optional) 
     * @return The shift creation results.
     */
    shifts(caregiverId: number, overrideWarnings?: boolean | undefined, body?: ShiftCreateRequest | undefined): Observable<ShiftCreateResponse> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/shifts?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (overrideWarnings === null)
            throw new globalThis.Error("The parameter 'overrideWarnings' cannot be null.");
        else if (overrideWarnings !== undefined)
            url_ += "overrideWarnings=" + encodeURIComponent("" + overrideWarnings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftCreateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftCreateResponse>;
        }));
    }

    protected processShifts(response: HttpResponseBase): Observable<ShiftCreateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftCreateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submits one or more existing shifts for the given caregiver.
     * @param overrideWarnings (optional) 
     * @param body (optional) 
     * @return The shift submission results.
     */
    submit(caregiverId: number, overrideWarnings?: boolean | undefined, body?: ShiftSubmitRequest[] | undefined): Observable<ShiftSubmitResponse[]> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/shifts/submit?";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (overrideWarnings === null)
            throw new globalThis.Error("The parameter 'overrideWarnings' cannot be null.");
        else if (overrideWarnings !== undefined)
            url_ += "overrideWarnings=" + encodeURIComponent("" + overrideWarnings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSubmitResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSubmitResponse[]>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<ShiftSubmitResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftSubmitResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a shift for the given caregiver.
     * @param body (optional) 
     * @return The shift removal results.
     */
    remove(caregiverId: number, body?: ShiftRemoveRequest | undefined): Observable<CreateAdjustmentResponse> {
        let url_ = this.baseUrl + "/api/caregivers/{caregiverId}/shifts/remove";
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAdjustmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAdjustmentResponse>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<CreateAdjustmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAdjustmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the participants associated with a designated representative.
     * @return The associated participants.
     */
    participantsAll2(drId: number): Observable<ParticipantDetailsResponseDateRanges[]> {
        let url_ = this.baseUrl + "/api/dr/{drId}/participants";
        if (drId === undefined || drId === null)
            throw new globalThis.Error("The parameter 'drId' must be defined.");
        url_ = url_.replace("{drId}", encodeURIComponent("" + drId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDetailsResponseDateRanges[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDetailsResponseDateRanges[]>;
        }));
    }

    protected processParticipantsAll2(response: HttpResponseBase): Observable<ParticipantDetailsResponseDateRanges[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantDetailsResponseDateRanges.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the participants associated with an employer of record.
     * @return The associated participants.
     */
    participantsAll3(eorId: number): Observable<ParticipantDetailsResponseDateRanges[]> {
        let url_ = this.baseUrl + "/api/eor/{eorId}/participants";
        if (eorId === undefined || eorId === null)
            throw new globalThis.Error("The parameter 'eorId' must be defined.");
        url_ = url_.replace("{eorId}", encodeURIComponent("" + eorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsAll3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsAll3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDetailsResponseDateRanges[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDetailsResponseDateRanges[]>;
        }));
    }

    protected processParticipantsAll3(response: HttpResponseBase): Observable<ParticipantDetailsResponseDateRanges[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantDetailsResponseDateRanges.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Caregivers associated with a participant and the given date range.
     * @return The associated participants.
     */
    caregiversAll(participantId: number): Observable<CaregiverResponse[]> {
        let url_ = this.baseUrl + "/api/participants/{participantId}/caregivers";
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaregiversAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaregiversAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverResponse[]>;
        }));
    }

    protected processCaregiversAll(response: HttpResponseBase): Observable<CaregiverResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the service codes by caregivers
     * @param caregiverId (optional) 
     * @param docTypes (optional) 
     * @return Success
     */
    services(participantId: number, caregiverId?: number | undefined, docTypes?: DocumentType[] | undefined): Observable<ServicesByCaregiverResponse> {
        let url_ = this.baseUrl + "/api/participants/{participantId}/authorizations/services?";
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (docTypes === null)
            throw new globalThis.Error("The parameter 'docTypes' cannot be null.");
        else if (docTypes !== undefined)
            docTypes && docTypes.forEach(item => { url_ += "docTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicesByCaregiverResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicesByCaregiverResponse>;
        }));
    }

    protected processServices(response: HttpResponseBase): Observable<ServicesByCaregiverResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicesByCaregiverResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the authorization service details for a participant
     * @param docTypes (optional) 
     * @param serviceDate (optional) 
     * @return Success
     */
    details(participantId: number, docTypes?: DocumentType[] | undefined, serviceDate?: string | undefined): Observable<ParticipantAuthorizationServicesResponse[]> {
        let url_ = this.baseUrl + "/api/participants/{participantId}/authorizations/services/details?";
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (docTypes === null)
            throw new globalThis.Error("The parameter 'docTypes' cannot be null.");
        else if (docTypes !== undefined)
            docTypes && docTypes.forEach(item => { url_ += "docTypes=" + encodeURIComponent("" + item) + "&"; });
        if (serviceDate === null)
            throw new globalThis.Error("The parameter 'serviceDate' cannot be null.");
        else if (serviceDate !== undefined)
            url_ += "serviceDate=" + encodeURIComponent("" + serviceDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantAuthorizationServicesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantAuthorizationServicesResponse[]>;
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<ParticipantAuthorizationServicesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantAuthorizationServicesResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the service codes, tasks, and EVV requirement associated with a participant, caregiver, and the given date range. May be filtered by doctype.
     * @param docType (optional) 
     * @return Success
     */
    caregivers(participantId: number, caregiverId: number, date: string, docType?: DocumentType | undefined): Observable<ParticipantShiftInformationResponse> {
        let url_ = this.baseUrl + "/api/participants/{participantId}/caregivers/{caregiverId}?";
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (caregiverId === undefined || caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (docType === null)
            throw new globalThis.Error("The parameter 'docType' cannot be null.");
        else if (docType !== undefined)
            url_ += "docType=" + encodeURIComponent("" + docType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaregivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaregivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantShiftInformationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantShiftInformationResponse>;
        }));
    }

    protected processCaregivers(response: HttpResponseBase): Observable<ParticipantShiftInformationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantShiftInformationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a shift for the given participant.
     * @param body (optional) 
     * @return The shift removal results.
     */
    remove2(participantId: number, body?: ShiftRemoveRequest | undefined): Observable<CreateAdjustmentResponse> {
        let url_ = this.baseUrl + "/api/participants/{participantId}/shifts/remove";
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAdjustmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAdjustmentResponse>;
        }));
    }

    protected processRemove2(response: HttpResponseBase): Observable<CreateAdjustmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAdjustmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current status of the service.
     * @return The service is available.
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The service is unavailable.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddressRequest implements IAddressRequest {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): AddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddressRequest {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class AddressResponse implements IAddressResponse {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): AddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddressResponse {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class CaregiverParticipantRelationshipStatusDateRange implements ICaregiverParticipantRelationshipStatusDateRange {
    startDate?: string;
    endDate?: string;
    isActive?: boolean;

    constructor(data?: ICaregiverParticipantRelationshipStatusDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationshipStatusDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationshipStatusDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICaregiverParticipantRelationshipStatusDateRange {
    startDate?: string;
    endDate?: string;
    isActive?: boolean;
}

export class CaregiverResponse implements ICaregiverResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActiveDates?: CaregiverParticipantRelationshipStatusDateRange[] | undefined;

    constructor(data?: ICaregiverResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["isActiveDates"])) {
                this.isActiveDates = [] as any;
                for (let item of _data["isActiveDates"])
                    this.isActiveDates!.push(CaregiverParticipantRelationshipStatusDateRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.isActiveDates)) {
            data["isActiveDates"] = [];
            for (let item of this.isActiveDates)
                data["isActiveDates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaregiverResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActiveDates?: CaregiverParticipantRelationshipStatusDateRange[] | undefined;
}

export class CaregiverWeeklyWWLResponse implements ICaregiverWeeklyWWLResponse {
    /** Gets or sets the WWL hours. */
    wwlHours?: number;
    /** Gets or sets the calendar date. */
    calendarDate?: string;

    constructor(data?: ICaregiverWeeklyWWLResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wwlHours = _data["wwlHours"];
            this.calendarDate = _data["calendarDate"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyWWLResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyWWLResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wwlHours"] = this.wwlHours;
        data["calendarDate"] = this.calendarDate;
        return data;
    }
}

export interface ICaregiverWeeklyWWLResponse {
    /** Gets or sets the WWL hours. */
    wwlHours?: number;
    /** Gets or sets the calendar date. */
    calendarDate?: string;
}

export enum CommentsRequired {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateAdjustmentResponse implements ICreateAdjustmentResponse {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: ICreateAdjustmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateAdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdjustmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateAdjustmentResponse {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class DateRange implements IDateRange {
    startDate?: string;
    endDate?: string;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IDateRange {
    startDate?: string;
    endDate?: string;
}

export class DateRangeResponse implements IDateRangeResponse {
    startDate?: string;
    endDate?: string;

    constructor(data?: IDateRangeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): DateRangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IDateRangeResponse {
    startDate?: string;
    endDate?: string;
}

export enum DocumentType {
    GHA = "GHA",
    GHS = "GHS",
    MLG = "MLG",
    SHF = "SHF",
    VDR = "VDR",
}

export class ElectronicVisitVerificationResponse implements IElectronicVisitVerificationResponse {
    exceptionReasonRequired?: boolean;
    exceptionReasons?: EvvExceptionReasonResponse[] | undefined;
    required?: boolean;

    constructor(data?: IElectronicVisitVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionReasonRequired = _data["exceptionReasonRequired"];
            if (Array.isArray(_data["exceptionReasons"])) {
                this.exceptionReasons = [] as any;
                for (let item of _data["exceptionReasons"])
                    this.exceptionReasons!.push(EvvExceptionReasonResponse.fromJS(item));
            }
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): ElectronicVisitVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicVisitVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionReasonRequired"] = this.exceptionReasonRequired;
        if (Array.isArray(this.exceptionReasons)) {
            data["exceptionReasons"] = [];
            for (let item of this.exceptionReasons)
                data["exceptionReasons"].push(item ? item.toJSON() : undefined as any);
        }
        data["required"] = this.required;
        return data;
    }
}

export interface IElectronicVisitVerificationResponse {
    exceptionReasonRequired?: boolean;
    exceptionReasons?: EvvExceptionReasonResponse[] | undefined;
    required?: boolean;
}

export class EmployerDetailsResponse implements IEmployerDetailsResponse {
    id?: number;
    ecn?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isOkToWork?: boolean;
    services?: EmployerServiceResponse[] | undefined;

    constructor(data?: IEmployerDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ecn = _data["ecn"];
            this.displayName = _data["displayName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isOkToWork = _data["isOkToWork"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(EmployerServiceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ecn"] = this.ecn;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isOkToWork"] = this.isOkToWork;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmployerDetailsResponse {
    id?: number;
    ecn?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isOkToWork?: boolean;
    services?: EmployerServiceResponse[] | undefined;
}

export class EmployerResponse implements IEmployerResponse {
    id?: number;
    ecn?: string | undefined;
    displayname?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IEmployerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ecn = _data["ecn"];
            this.displayname = _data["displayname"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): EmployerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ecn"] = this.ecn;
        data["displayname"] = this.displayname;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IEmployerResponse {
    id?: number;
    ecn?: string | undefined;
    displayname?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class EmployerServiceResponse implements IEmployerServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    commentsRequired?: CommentsRequired;
    documentTypes?: string[] | undefined;
    dateRanges?: DateRange[] | undefined;
    isDMCmReadOnly?: boolean;
    isOkToWorkExempt?: boolean;

    constructor(data?: IEmployerServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.commentsRequired = _data["commentsRequired"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRange.fromJS(item));
            }
            this.isDMCmReadOnly = _data["isDMCmReadOnly"];
            this.isOkToWorkExempt = _data["isOkToWorkExempt"];
        }
    }

    static fromJS(data: any): EmployerServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["commentsRequired"] = this.commentsRequired;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDMCmReadOnly"] = this.isDMCmReadOnly;
        data["isOkToWorkExempt"] = this.isOkToWorkExempt;
        return data;
    }
}

export interface IEmployerServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    commentsRequired?: CommentsRequired;
    documentTypes?: string[] | undefined;
    dateRanges?: DateRange[] | undefined;
    isDMCmReadOnly?: boolean;
    isOkToWorkExempt?: boolean;
}

export class ErrorDetailsResponse implements IErrorDetailsResponse {
    ruleError?: string | undefined;
    ruleErrorId?: string | undefined;
    userFriendlyError?: string | undefined;

    constructor(data?: IErrorDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleError = _data["ruleError"];
            this.ruleErrorId = _data["ruleErrorId"];
            this.userFriendlyError = _data["userFriendlyError"];
        }
    }

    static fromJS(data: any): ErrorDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleError"] = this.ruleError;
        data["ruleErrorId"] = this.ruleErrorId;
        data["userFriendlyError"] = this.userFriendlyError;
        return data;
    }
}

export interface IErrorDetailsResponse {
    ruleError?: string | undefined;
    ruleErrorId?: string | undefined;
    userFriendlyError?: string | undefined;
}

export class EvvExceptionReasonResponse implements IEvvExceptionReasonResponse {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IEvvExceptionReasonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EvvExceptionReasonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IEvvExceptionReasonResponse {
    code?: string | undefined;
    description?: string | undefined;
}

export class ParticipantAuthorizationServicesResponse implements IParticipantAuthorizationServicesResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    dateRanges?: DateRangeResponse[] | undefined;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;
    acn?: string | undefined;
    billCode?: string | undefined;

    constructor(data?: IParticipantAuthorizationServicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRangeResponse.fromJS(item));
            }
            this.isDMCmReadOnly = _data["isDMCmReadOnly"];
            this.masterServiceCode = _data["masterServiceCode"];
            this.acn = _data["acn"];
            this.billCode = _data["billCode"];
        }
    }

    static fromJS(data: any): ParticipantAuthorizationServicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAuthorizationServicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDMCmReadOnly"] = this.isDMCmReadOnly;
        data["masterServiceCode"] = this.masterServiceCode;
        data["acn"] = this.acn;
        data["billCode"] = this.billCode;
        return data;
    }
}

export interface IParticipantAuthorizationServicesResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    dateRanges?: DateRangeResponse[] | undefined;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;
    acn?: string | undefined;
    billCode?: string | undefined;
}

export class ParticipantDetailsResponse implements IParticipantDetailsResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isLiveIn?: boolean;
    isOkToDrive?: boolean;
    isOkToWork?: boolean;
    electronicVisitVerification?: ElectronicVisitVerificationResponse;
    services?: ParticipantServiceResponse[] | undefined;
    workWeekLimit?: WorkWeekLimitResponse;
    homeAddress?: AddressResponse;

    constructor(data?: IParticipantDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isLiveIn = _data["isLiveIn"];
            this.isOkToDrive = _data["isOkToDrive"];
            this.isOkToWork = _data["isOkToWork"];
            this.electronicVisitVerification = _data["electronicVisitVerification"] ? ElectronicVisitVerificationResponse.fromJS(_data["electronicVisitVerification"]) : undefined as any;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ParticipantServiceResponse.fromJS(item));
            }
            this.workWeekLimit = _data["workWeekLimit"] ? WorkWeekLimitResponse.fromJS(_data["workWeekLimit"]) : undefined as any;
            this.homeAddress = _data["homeAddress"] ? AddressResponse.fromJS(_data["homeAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParticipantDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isLiveIn"] = this.isLiveIn;
        data["isOkToDrive"] = this.isOkToDrive;
        data["isOkToWork"] = this.isOkToWork;
        data["electronicVisitVerification"] = this.electronicVisitVerification ? this.electronicVisitVerification.toJSON() : undefined as any;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        data["workWeekLimit"] = this.workWeekLimit ? this.workWeekLimit.toJSON() : undefined as any;
        data["homeAddress"] = this.homeAddress ? this.homeAddress.toJSON() : undefined as any;
        return data;
    }
}

export interface IParticipantDetailsResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isLiveIn?: boolean;
    isOkToDrive?: boolean;
    isOkToWork?: boolean;
    electronicVisitVerification?: ElectronicVisitVerificationResponse;
    services?: ParticipantServiceResponse[] | undefined;
    workWeekLimit?: WorkWeekLimitResponse;
    homeAddress?: AddressResponse;
}

export class ParticipantDetailsResponseDateRanges implements IParticipantDetailsResponseDateRanges {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateRanges?: ParticipantDetailsStartEndDate[] | undefined;

    constructor(data?: IParticipantDetailsResponseDateRanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(ParticipantDetailsStartEndDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantDetailsResponseDateRanges {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDetailsResponseDateRanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParticipantDetailsResponseDateRanges {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateRanges?: ParticipantDetailsStartEndDate[] | undefined;
}

export class ParticipantDetailsStartEndDate implements IParticipantDetailsStartEndDate {
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IParticipantDetailsStartEndDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): ParticipantDetailsStartEndDate {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDetailsStartEndDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IParticipantDetailsStartEndDate {
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export class ParticipantResponse implements IParticipantResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isLiveIn?: boolean;
    workWeekLimits?: CaregiverWeeklyWWLResponse[] | undefined;

    constructor(data?: IParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isLiveIn = _data["isLiveIn"];
            if (Array.isArray(_data["workWeekLimits"])) {
                this.workWeekLimits = [] as any;
                for (let item of _data["workWeekLimits"])
                    this.workWeekLimits!.push(CaregiverWeeklyWWLResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isLiveIn"] = this.isLiveIn;
        if (Array.isArray(this.workWeekLimits)) {
            data["workWeekLimits"] = [];
            for (let item of this.workWeekLimits)
                data["workWeekLimits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParticipantResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isLiveIn?: boolean;
    workWeekLimits?: CaregiverWeeklyWWLResponse[] | undefined;
}

export class ParticipantServiceResponse implements IParticipantServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    isOkToWorkExempt?: boolean;
    isWithinGracePeriod?: boolean;
    programId?: number | undefined;
    taskRequired?: boolean;
    commentsRequiredValue?: CommentsRequired;
    tasks?: TaskResponse[] | undefined;
    respectEVVConfiguration?: boolean;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;

    constructor(data?: IParticipantServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.isOkToWorkExempt = _data["isOkToWorkExempt"];
            this.isWithinGracePeriod = _data["isWithinGracePeriod"];
            this.programId = _data["programId"];
            this.taskRequired = _data["taskRequired"];
            this.commentsRequiredValue = _data["commentsRequiredValue"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskResponse.fromJS(item));
            }
            this.respectEVVConfiguration = _data["respectEVVConfiguration"];
            this.isDMCmReadOnly = _data["isDMCmReadOnly"];
            this.masterServiceCode = _data["masterServiceCode"];
        }
    }

    static fromJS(data: any): ParticipantServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["isOkToWorkExempt"] = this.isOkToWorkExempt;
        data["isWithinGracePeriod"] = this.isWithinGracePeriod;
        data["programId"] = this.programId;
        data["taskRequired"] = this.taskRequired;
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["respectEVVConfiguration"] = this.respectEVVConfiguration;
        data["isDMCmReadOnly"] = this.isDMCmReadOnly;
        data["masterServiceCode"] = this.masterServiceCode;
        return data;
    }
}

export interface IParticipantServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    isOkToWorkExempt?: boolean;
    isWithinGracePeriod?: boolean;
    programId?: number | undefined;
    taskRequired?: boolean;
    commentsRequiredValue?: CommentsRequired;
    tasks?: TaskResponse[] | undefined;
    respectEVVConfiguration?: boolean;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;
}

export class ParticipantShiftInformationResponse implements IParticipantShiftInformationResponse {
    services?: ShiftInformationServiceResponse[] | undefined;
    electronicVisitVerification?: ElectronicVisitVerificationResponse;

    constructor(data?: IParticipantShiftInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ShiftInformationServiceResponse.fromJS(item));
            }
            this.electronicVisitVerification = _data["electronicVisitVerification"] ? ElectronicVisitVerificationResponse.fromJS(_data["electronicVisitVerification"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParticipantShiftInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantShiftInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        data["electronicVisitVerification"] = this.electronicVisitVerification ? this.electronicVisitVerification.toJSON() : undefined as any;
        return data;
    }
}

export interface IParticipantShiftInformationResponse {
    services?: ShiftInformationServiceResponse[] | undefined;
    electronicVisitVerification?: ElectronicVisitVerificationResponse;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RuleFailureResponse implements IRuleFailureResponse {
    rule?: string | undefined;
    priority?: number;
    status?: string | undefined;
    errors?: string[] | undefined;
    errorDetails?: ErrorDetailsResponse[] | undefined;

    constructor(data?: IRuleFailureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rule = _data["rule"];
            this.priority = _data["priority"];
            this.status = _data["status"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["errorDetails"])) {
                this.errorDetails = [] as any;
                for (let item of _data["errorDetails"])
                    this.errorDetails!.push(ErrorDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleFailureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RuleFailureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule;
        data["priority"] = this.priority;
        data["status"] = this.status;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.errorDetails)) {
            data["errorDetails"] = [];
            for (let item of this.errorDetails)
                data["errorDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRuleFailureResponse {
    rule?: string | undefined;
    priority?: number;
    status?: string | undefined;
    errors?: string[] | undefined;
    errorDetails?: ErrorDetailsResponse[] | undefined;
}

export class ServiceResponse implements IServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    isInternal?: boolean;
    documentTypes?: DocumentType[] | undefined;
    dateRanges?: DateRangeResponse[] | undefined;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;

    constructor(data?: IServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.isInternal = _data["isInternal"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRangeResponse.fromJS(item));
            }
            this.isDMCmReadOnly = _data["isDMCmReadOnly"];
            this.masterServiceCode = _data["masterServiceCode"];
        }
    }

    static fromJS(data: any): ServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["isInternal"] = this.isInternal;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDMCmReadOnly"] = this.isDMCmReadOnly;
        data["masterServiceCode"] = this.masterServiceCode;
        return data;
    }
}

export interface IServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    isInternal?: boolean;
    documentTypes?: DocumentType[] | undefined;
    dateRanges?: DateRangeResponse[] | undefined;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;
}

export class ServicesByCaregiverResponse implements IServicesByCaregiverResponse {
    servicesByCaregiverId?: { [key: string]: ServiceResponse[]; } | undefined;

    constructor(data?: IServicesByCaregiverResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["servicesByCaregiverId"]) {
                this.servicesByCaregiverId = {} as any;
                for (let key in _data["servicesByCaregiverId"]) {
                    if (_data["servicesByCaregiverId"].hasOwnProperty(key))
                        (this.servicesByCaregiverId as any)![key] = _data["servicesByCaregiverId"][key] ? _data["servicesByCaregiverId"][key].map((i: any) => ServiceResponse.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ServicesByCaregiverResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesByCaregiverResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.servicesByCaregiverId) {
            data["servicesByCaregiverId"] = {};
            for (let key in this.servicesByCaregiverId) {
                if (this.servicesByCaregiverId.hasOwnProperty(key))
                    (data["servicesByCaregiverId"] as any)[key] = (this.servicesByCaregiverId as any)[key];
            }
        }
        return data;
    }
}

export interface IServicesByCaregiverResponse {
    servicesByCaregiverId?: { [key: string]: ServiceResponse[]; } | undefined;
}

export class ShiftCreateRequest implements IShiftCreateRequest {
    comment?: string | undefined;
    date?: string;
    /** Required when type is Gha. */
    ecn?: string | undefined;
    evvExceptionReason?: string | undefined;
    /** Only allowed for CDWA, default is false. */
    isPsst?: boolean | undefined;
    /** Required when type is not Gha. */
    participantId?: number | undefined;
    serviceCode?: string | undefined;
    status?: ShiftStatus;
    tasks?: string[] | undefined;
    /** Required when type is Shift. */
    timeIn?: string | undefined;
    /** Required when type is Shift. */
    timeOut?: string | undefined;
    type?: ShiftType;
    /** Required when type is not Shift. */
    units?: number | undefined;
    startAddress?: AddressRequest;
    endAddress?: AddressRequest;
    isStartLocationSameAsParticipant?: boolean;

    constructor(data?: IShiftCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.date = _data["date"];
            this.ecn = _data["ecn"];
            this.evvExceptionReason = _data["evvExceptionReason"];
            this.isPsst = _data["isPsst"];
            this.participantId = _data["participantId"];
            this.serviceCode = _data["serviceCode"];
            this.status = _data["status"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.timeIn = _data["timeIn"];
            this.timeOut = _data["timeOut"];
            this.type = _data["type"];
            this.units = _data["units"];
            this.startAddress = _data["startAddress"] ? AddressRequest.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? AddressRequest.fromJS(_data["endAddress"]) : undefined as any;
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
        }
    }

    static fromJS(data: any): ShiftCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["date"] = this.date;
        data["ecn"] = this.ecn;
        data["evvExceptionReason"] = this.evvExceptionReason;
        data["isPsst"] = this.isPsst;
        data["participantId"] = this.participantId;
        data["serviceCode"] = this.serviceCode;
        data["status"] = this.status;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["timeIn"] = this.timeIn;
        data["timeOut"] = this.timeOut;
        data["type"] = this.type;
        data["units"] = this.units;
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        return data;
    }
}

export interface IShiftCreateRequest {
    comment?: string | undefined;
    date?: string;
    /** Required when type is Gha. */
    ecn?: string | undefined;
    evvExceptionReason?: string | undefined;
    /** Only allowed for CDWA, default is false. */
    isPsst?: boolean | undefined;
    /** Required when type is not Gha. */
    participantId?: number | undefined;
    serviceCode?: string | undefined;
    status?: ShiftStatus;
    tasks?: string[] | undefined;
    /** Required when type is Shift. */
    timeIn?: string | undefined;
    /** Required when type is Shift. */
    timeOut?: string | undefined;
    type?: ShiftType;
    /** Required when type is not Shift. */
    units?: number | undefined;
    startAddress?: AddressRequest;
    endAddress?: AddressRequest;
    isStartLocationSameAsParticipant?: boolean;
}

export class ShiftCreateResponse implements IShiftCreateResponse {
    success?: boolean;
    ruleFailures?: RuleFailureResponse[] | undefined;

    constructor(data?: IShiftCreateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["ruleFailures"])) {
                this.ruleFailures = [] as any;
                for (let item of _data["ruleFailures"])
                    this.ruleFailures!.push(RuleFailureResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.ruleFailures)) {
            data["ruleFailures"] = [];
            for (let item of this.ruleFailures)
                data["ruleFailures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiftCreateResponse {
    success?: boolean;
    ruleFailures?: RuleFailureResponse[] | undefined;
}

export class ShiftInformationServiceResponse implements IShiftInformationServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    programId?: number | undefined;
    tasks?: TaskResponse[] | undefined;
    respectEVVConfiguration?: boolean;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;

    constructor(data?: IShiftInformationServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.programId = _data["programId"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskResponse.fromJS(item));
            }
            this.respectEVVConfiguration = _data["respectEVVConfiguration"];
            this.isDMCmReadOnly = _data["isDMCmReadOnly"];
            this.masterServiceCode = _data["masterServiceCode"];
        }
    }

    static fromJS(data: any): ShiftInformationServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftInformationServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["programId"] = this.programId;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["respectEVVConfiguration"] = this.respectEVVConfiguration;
        data["isDMCmReadOnly"] = this.isDMCmReadOnly;
        data["masterServiceCode"] = this.masterServiceCode;
        return data;
    }
}

export interface IShiftInformationServiceResponse {
    code?: string | undefined;
    description?: string | undefined;
    documentTypes?: DocumentType[] | undefined;
    programId?: number | undefined;
    tasks?: TaskResponse[] | undefined;
    respectEVVConfiguration?: boolean;
    isDMCmReadOnly?: boolean;
    masterServiceCode?: string | undefined;
}

export class ShiftRemoveRequest implements IShiftRemoveRequest {
    /** Required when Type is not Gha. */
    participantId?: number | undefined;
    reasonId?: number;
    reason?: string | undefined;
    transactionId?: string | undefined;
    type?: ShiftType;

    constructor(data?: IShiftRemoveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.reasonId = _data["reasonId"];
            this.reason = _data["reason"];
            this.transactionId = _data["transactionId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ShiftRemoveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftRemoveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["reasonId"] = this.reasonId;
        data["reason"] = this.reason;
        data["transactionId"] = this.transactionId;
        data["type"] = this.type;
        return data;
    }
}

export interface IShiftRemoveRequest {
    /** Required when Type is not Gha. */
    participantId?: number | undefined;
    reasonId?: number;
    reason?: string | undefined;
    transactionId?: string | undefined;
    type?: ShiftType;
}

export enum ShiftStatus {
    Saved = "Saved",
    Submitted = "Submitted",
}

export class ShiftSubmitRequest implements IShiftSubmitRequest {
    evvExceptionReason?: string | undefined;
    /** Required when Type is not Gha. */
    participantId?: number | undefined;
    transactionId?: string | undefined;
    type?: ShiftType;
    caregiverComments?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
    tasks?: string[] | undefined;
    serviceCode?: string | undefined;
    miles?: number | undefined;
    units?: number | undefined;
    isPsst?: boolean | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    startAddress?: AddressRequest;
    endAddress?: AddressRequest;

    constructor(data?: IShiftSubmitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evvExceptionReason = _data["evvExceptionReason"];
            this.participantId = _data["participantId"];
            this.transactionId = _data["transactionId"];
            this.type = _data["type"];
            this.caregiverComments = _data["caregiverComments"];
            this.timeIn = _data["timeIn"];
            this.timeOut = _data["timeOut"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.serviceCode = _data["serviceCode"];
            this.miles = _data["miles"];
            this.units = _data["units"];
            this.isPsst = _data["isPsst"];
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.startAddress = _data["startAddress"] ? AddressRequest.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? AddressRequest.fromJS(_data["endAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftSubmitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSubmitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evvExceptionReason"] = this.evvExceptionReason;
        data["participantId"] = this.participantId;
        data["transactionId"] = this.transactionId;
        data["type"] = this.type;
        data["caregiverComments"] = this.caregiverComments;
        data["timeIn"] = this.timeIn;
        data["timeOut"] = this.timeOut;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["serviceCode"] = this.serviceCode;
        data["miles"] = this.miles;
        data["units"] = this.units;
        data["isPsst"] = this.isPsst;
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        return data;
    }
}

export interface IShiftSubmitRequest {
    evvExceptionReason?: string | undefined;
    /** Required when Type is not Gha. */
    participantId?: number | undefined;
    transactionId?: string | undefined;
    type?: ShiftType;
    caregiverComments?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
    tasks?: string[] | undefined;
    serviceCode?: string | undefined;
    miles?: number | undefined;
    units?: number | undefined;
    isPsst?: boolean | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    startAddress?: AddressRequest;
    endAddress?: AddressRequest;
}

export class ShiftSubmitResponse implements IShiftSubmitResponse {
    transactionId?: string | undefined;
    success?: boolean;
    ruleFailures?: RuleFailureResponse[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IShiftSubmitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.success = _data["success"];
            if (Array.isArray(_data["ruleFailures"])) {
                this.ruleFailures = [] as any;
                for (let item of _data["ruleFailures"])
                    this.ruleFailures!.push(RuleFailureResponse.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ShiftSubmitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSubmitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["success"] = this.success;
        if (Array.isArray(this.ruleFailures)) {
            data["ruleFailures"] = [];
            for (let item of this.ruleFailures)
                data["ruleFailures"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IShiftSubmitResponse {
    transactionId?: string | undefined;
    success?: boolean;
    ruleFailures?: RuleFailureResponse[] | undefined;
    errorMessage?: string | undefined;
}

export enum ShiftType {
    Gha = "Gha",
    Ghs = "Ghs",
    Mileage = "Mileage",
    Shift = "Shift",
    Vendor = "Vendor",
}

export class TaskResponse implements ITaskResponse {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaskResponse {
    code?: string | undefined;
    description?: string | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class WorkWeekLimitResponse implements IWorkWeekLimitResponse {
    total?: number;
    remaining?: number;

    constructor(data?: IWorkWeekLimitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.remaining = _data["remaining"];
        }
    }

    static fromJS(data: any): WorkWeekLimitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkWeekLimitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["remaining"] = this.remaining;
        return data;
    }
}

export interface IWorkWeekLimitResponse {
    total?: number;
    remaining?: number;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}